import React from "react";
import BarraSupDent from "../../../commons/BarraSupDent";
import Title from "../../../pages/Login/Components/title/title";
import NavbarTechnician from "../../../commons/NavbarTechnician";

class Job_canceled extends React.Component {
  // fake authentication Promise
  authenticate() {
    return new Promise((resolve) => setTimeout(resolve, 2000)); // 2 seconds
  }

  componentDidMount() {
    this.authenticate().then(() => {
      const ele = document.getElementById("ipl-progress-indicator");
      if (ele) {
        // fade out
        ele.classList.add("available");
        setTimeout(() => {
          // remove from DOM
          ele.outerHTML = "";
        }, 2000);
      }
    });
  }

  render() {
    return (
      <React.Fragment>
        <BarraSupDent />
        <div className="container pb-5 mb-5">
          <b>
            <Title text="CANCELED" />
          </b>
          <div className="row">
            <div className="col">
              <label className="lblSize">
                <b>Oct 1st 3:00 PM</b>
              </label>
              <label className="lblSize mt-3">Carl</label>
              <label className="lblSize">2015</label>
              <label className="lblSize">Honda Civic</label>
              <label className="lblSize">670 Sepulveda Blvd</label>
              <label className="lblSize">Mar Visa, CA 90291</label>
            </div>
            <div className="col">
              <label className="lblSize text-center">
                <b>$350</b>
              </label>
            </div>
          </div>
          <div className="text-center mt-4">
            <div className="row">
              <div className="col colSize">
                <img
                  src={"https://picsum.photos/90/90"}
                  alt="example"
                  className="mx-auto"
                />
              </div>
              <div className="col colSize">
                <img
                  src={"https://picsum.photos/90/90"}
                  alt="example"
                  className="mx-auto"
                />
              </div>
              <div className="col colSize">
                <img
                  src={"https://picsum.photos/90/90"}
                  alt="example"
                  className="mx-auto"
                />
              </div>
            </div>
          </div>
          <label className="lblSize mt-5">
            <b>Notes</b>
          </label>
          <label className="lblSize mb-5">
            Aluminum Pannel. Paint may not be original
          </label>
          <label className="lblSize mt-5">
            <b>Photo After repair</b>
          </label>
          <img src={"https://picsum.photos/90/90"} alt="example" />
        </div>
        <NavbarTechnician />
      </React.Fragment>
    );
  }
}
export default Job_canceled;
